<template>
  <b-row>
    <b-col sm="12">
      <h3>Vehicles</h3>
      <p class="text-muted">List all vehicles here.  Loan months should be total months financed. Add vehicles with debt only.</p>
      <b-table v-if="value.vehicles.length > 0" :small="true" hover :items="value.vehicles" :fields="fields" @row-clicked="edit" foot-clone>
        <template v-slot:cell(balance)="data">
          <dollars :value="data.value"></dollars>
        </template>
        <template v-slot:cell(minimumPayment)="data">
          <dollars :value="data.value" :postfix="'mo'"></dollars>
        </template>
        <template v-slot:cell(actualPayment)="data">
          <dollars :value="data.value" :postfix="'mo'"></dollars>
        </template>
        <template v-slot:cell(rate)="data">
          <percent :value="data.value"></percent>
        </template>
        <template v-slot:cell(delete)="data">
          <div class="text-right">
            <b-button size="sm" variant="ghost-danger" v-on:click="remove(data.item)"><i class="fa fa-remove"></i></b-button>
          </div>
        </template>
        <template v-slot:foot(make)><span></span></template>
        <template v-slot:foot(model)><span></span></template>
        <template v-slot:foot(year)><span></span></template>
        <template v-slot:foot(balance)>
          <dollars :value="totalBalance"></dollars>
        </template>
        <template v-slot:foot(minimumPayment)>
          <dollars :value="totalMinimumPayment" :postfix="'mo'"></dollars>
        </template>
        <template v-slot:foot(actualPayment)>
          <dollars :value="totalActualPayment" :postfix="'mo'"></dollars>
        </template>
        <template v-slot:foot(rate)><span></span></template>
        <template v-slot:foot(months)><span></span></template>
      </b-table>

      <!-- Add Vehicle -->
      <b-button size="sm" variant="outline-success" v-on:click="add()">
        <i class="fa fa-plus"></i>&nbsp;Add Vehicle
      </b-button>
      <vehicle-modal @save="save"></vehicle-modal>
    </b-col>
  </b-row>
</template>
<script>
import Dollars from '@/components/text/Dollars'
import Percent from '@/components/text/Percent'

import VehicleModal from '@/components/modals/VehicleModal'
export default {
  props: [ 'clientId', 'value' ],
  components: {
    VehicleModal,
    Dollars,
    Percent
  },
  computed: {
    totalBalance: function () {
      let total = 0.0
      this.value.vehicles.forEach(function(item) { total += parseFloat(item.balance) })
      return total
    },
    totalMinimumPayment: function () {
      let total = 0.0
      this.value.mortgages.forEach(function(item) { total += parseFloat(item.minimumPayment) })
      return total
    },
    totalActualPayment: function () {
      let total = 0.0
      this.value.mortgages.forEach(function(item) { total += parseFloat(item.actualPayment) })
      return total
    }
  },
  data () {
    return {
      fields: [
        { key: 'make' },
        { key: 'model' },
        { key: 'year' },
        { key: 'balance', class: "numeric" },
        { key: 'minimumPayment', class: 'numeric' },
        { key: 'actualPayment', class: 'numeric' },
        { key: 'rate', class: "numeric" },
        { key: 'months', class: "numeric" },
        { key: 'delete', label: '', class: 'delete' }
      ],
      items: []
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:editVehicle')
    },
    edit (item) {
      let index = this.value.vehicles.indexOf(item)
      this.editing = index
      this.$bus.$emit('modal:editVehicle', item)
    },
    remove (item) {
      let token = this.$route.params.token
      this.$api.clients.intake.deleteVehicle({ token: token, id: item.id })
        .then(() => {
          this.$emit('update')
          this.$snotify.success('Vehicle Deleted Successfully')
        })
        .catch((err) => {
          this.$snotify.error('There was a problem removing the policy.')
        })
    },
    save (value) {
      let token = this.$route.params.token
      value.clientId = this.clientId
      if (value.id) {
        this.$api.clients.intake.updateVehicle({ token: token, id: value.id }, value)
          .then((response) => {
            this.$emit('update', value)
            this.$snotify.success('Vehicle Saved Successfully')
          })
          .catch((err) => {
            this.$snotify.error('There was a problem saving the Vehicle.')
          })
      } else {
        this.$api.clients.intake.createVehicle({ token: token }, value)
          .then((response) => {
            this.$emit('update', value)
            this.$snotify.success('Vehicle Added Successfully')
          })
          .catch((err) => {
            this.$snotify.error('There was a problem saving the Vehicle.')
          })
      }
    }
  }
}
</script>
